import React from 'react';
import DailyViewNavigation from './DailyViewNavigation';
import PageWithLeftNavLayout from './PageWithLeftNavLayout';

const DailyViewLayout = ({ date, children }) => {
  return (
    <PageWithLeftNavLayout leftNav={<DailyViewNavigation date={date} />}>
      {children}
    </PageWithLeftNavLayout>
  );
};

export default DailyViewLayout;
